import api from '../plugins/axios';
import moment from 'moment';

function handleError(error, blockMessage = '') {
  console.error(blockMessage, error);
}
export default {
  state: {
    posts: [],
    likes: {},
    loading: true,
    nextCursor: null,
    leaderboard: [],
    users: [],
  },
  getters: {
    preparedPosts(state, getters, rootState) {
      return state.posts.map((post) => {
        const data = { ...post };
        data.sender = rootState.settings.users.find((user) => user.id === post.from_id);
        data.receivers = rootState.settings.users.filter((user) => post.to_id.includes(user.id));
        data.value = rootState.auth.values.find((value) => value.id === post.value_id) || {};
        data.likes = { ...state.likes[data.id] };
        return data;
      });
    },
    leaderboard(state, getters, rootState) {
      return state.leaderboard
        .map((data) => {
          const user = rootState.settings.users.find((user) => user.id === data.user_id);
          return { ...user, ...data, score: data.current };
        })
        .filter((user) => user.state === 'accepted');
    },
  },
  actions: {
    async init({ commit }, { url = '/posts' }) {
      try {
        commit('setLoading', true);
        const response = await api.get(`${url}`);
        commit('setNextCursor', response.headers['x-next-cursor']);
        commit('setState', response.data);
      } finally {
        commit('setLoading', false);
      }
    },
    async loadPosts({ commit, state }, { url = '/posts', filter = '' }) {
      try {
        if (!state.nextCursor) {
          return;
        }
        commit('setLoading', true);
        const response = await api.get(`${url}?next_cursor=${state.nextCursor}&${filter}`);
        commit('setNextCursor', response.headers['x-next-cursor']);
        commit('addPosts', response.data.posts);
        commit('addUsers', response.data.users);
        commit('setLoading', false);
      } finally {
        commit('setLoading', false);
      }
    },
    async createPost({ commit, dispatch }, params) {
      let response = {};
      try {
        const { data } = await api.post('/posts', params);
        commit('addNewPost', data);
        dispatch('auth/updateScoreValue', data, { root: true });
        response = data;
      } catch (e) {
        response.errors = e.response?.data?.errors || [{ message: 'unknown' }];
        handleError(e, 'Error create post: ');
      }
      return response;
    },
    async removePost({ commit, dispatch, rootGetters }, post) {
      await api.delete(`/posts/${post.id}`);
      commit('removePost', post.id);
      if (moment(post.created_at) > moment().subtract(1, rootGetters['auth/limitPeriod']))
        dispatch('auth/updateScoreValue', { ...post, score: post.score * -1 }, { root: true });
    },
    async addLike({ commit }, postId) {
      const { data } = await api.post(`/posts/${postId}/like`);
      commit('updateLike', { postId, data });
    },
    async removeLike({ commit }, postId) {
      const { data } = await api.delete(`/posts/${postId}/like`);
      commit('updateLike', { postId, data });
    },
    async updatePostValue({ commit }, { id, value_id }) {
      try {
        const { data } = await api.put(`/posts/${id}`, { value_id });
        commit('updatePost', data);
      } catch (e) {
        handleError(e, 'Error update post value: ');
      }
    },
    async updateChecklist({ commit }, checklist) {
      try {
        const { data } = await api.put('/checklist', { checklist });
        commit('auth/setChecklist', data, { root: true });
      } catch (e) {
        handleError(e, 'Error update checklist: ');
      }
    },
    async dismissChecklist({ commit }) {
      try {
        await api.delete('/checklist');
        commit('auth/setChecklist', null, { root: true });
      } catch (e) {
        handleError(e, 'Error delete checklist: ');
      }
    },
    async loadLeaderboard({ commit }) {
      try {
        const { data } = await api.get('/leaderboards');
        commit('setState', { leaderboard: data });
      } catch (e) {
        handleError(e, 'Error load Leaderboard: ');
      }
    },
    async exportPosts(_, days = null) {
      const filter = days ? `?days=${days}` : '';
      const { data } = await api.get(`/posts.csv${filter}`, { responseType: 'blob' });
      return data;
    },
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
    setState(state, data) {
      Object.assign(state, data);
    },
    addPosts(state, posts) {
      state.posts.push(...posts);
    },
    addUsers(state, users) {
      state.users.push(...users);
    },
    addNewPost(state, post) {
      state.posts.unshift(post);
    },
    removePost(state, postId) {
      const index = state.posts.findIndex((post) => post.id === postId);
      state.posts.splice(index, 1);
    },
    setNextCursor(state, nextCursor) {
      state.nextCursor = nextCursor;
    },
    updateLike(state, { postId, data }) {
      state.likes[postId] = data;
    },
    updatePost(state, post) {
      Object.assign(
        state.posts.find((el) => el.id === post.id),
        post,
      );
    },
  },
  namespaced: true,
};
